import React, {Component} from 'react';

// Import custom components
import Title from './title.component';

class Account extends Component {

    render() {
        return (
            <div>
                <Title />

                <section className="content nopadding">

                    {this.props.children}

                </section>

            </div>
        );
    }
}

export default Account;
